'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { ensureGoogleAnalytics, hasAnalyticsMeasurementId } from '@/lib/google-analytics';

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

/**
 * GoogleAnalytics — Loads the GA4 gtag.js script with Consent Mode v2.
 *
 * Default consent is set to `denied` for both `analytics_storage` and
 * `ad_storage`. Consent is only granted when the user explicitly accepts
 * via the CookieConsentBanner component.
 *
 * If NEXT_PUBLIC_GA_MEASUREMENT_ID is not set or malformed, this component
 * renders nothing (graceful no-op for local development).
 */
export function GoogleAnalytics() {
  const pathname = usePathname();
  useEffect(() => { ensureGoogleAnalytics(); }, [pathname]);
  if (!hasAnalyticsMeasurementId() || pathname === '/homepage-preview' || pathname === '/tv/direct' || pathname === '/tv/probe') return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="lazyOnload"
        onReady={() => { ensureGoogleAnalytics(); }}
      />
    </>
  );
}
